export const TOOLTIP_MESSAGE = {
	INSTANCE_WITHOUT_VALID_LICENSE: 'Instance without valid license',
};
